import axios, { AxiosInstance } from "axios";
import { useCallback, useMemo } from "react";
export function useApi<T>(ApiClass: new (url: string, axios: AxiosInstance) => T) {


  const getApiAddress = useCallback((): string => {
    const v = process.env.REACT_APP_API_URL;
    if (!v || v === "NOT") return "https://localhost:7104";
    return v;
  }, []);
  const getGateApiAddress = useCallback((): string => {
    const v = process.env.REACT_APP_GATE_API_URL;
    if (!v || v === "NOT") return "https://localhost:7108";
    return v;
  }, []);

  const createAxios = useCallback((tokenKey?: string) => {
    const instance = axios.create();

    instance.interceptors.request.use(
      (config) => {
        // if (!config.headers) config.headers = {};
        config.headers["Content-Type"] = "application/json";
        config.headers["Accept"] = "application/json";
        config.headers["accept-language"] = 'cs';
        config.headers["TimeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tokenKey) {
          const t = localStorage.getItem(tokenKey);
          if (t) config.headers.Authorization = `Bearer ${t}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Minimal 401 handling: clear tokens and navigate to root (customize as needed)
    instance.interceptors.response.use(
      (r) => r,
      (error) => {
        const originalRequest = error.config;
        if (error?.response?.status === 401 && !originalRequest?._retry) {
          originalRequest._retry = true;
          // remove known token keys and reload — replace with refresh logic if you have one
          localStorage.removeItem("bearer");

          window.location.href = window.location.origin + "/";
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, []);

  const Unauthorized = useCallback((): T => {
    const axiosApiInstance = createAxios();
    return new ApiClass(getApiAddress(), axiosApiInstance);
  }, [ApiClass, createAxios, getApiAddress]);
  const UnauthorizedGate = useCallback((): T => {
    const axiosApiInstance = createAxios();
    return new ApiClass(getGateApiAddress(), axiosApiInstance);
  }, [ApiClass, createAxios, getGateApiAddress]);

  const Authorized = useCallback((): T => {
    const axiosApiInstance = createAxios("bearer");
    return new ApiClass(getApiAddress(), axiosApiInstance);
  }, [ApiClass, createAxios, getApiAddress]);


  const unauthorizedApi = useMemo(() => Unauthorized(), [Unauthorized]);
  const authorizedApi = useMemo(() => Authorized(), [Authorized]);
  const unauthorizedGateApi = useMemo(() => UnauthorizedGate(), [UnauthorizedGate]);

  return {
    unauthorizedApi,
    authorizedApi,
    unauthorizedFactory: Unauthorized,
    authorizedFactory: Authorized,
    unauthorizedGateFactory: UnauthorizedGate,
    unauthorizedGateApi
  };
}